import { React, useState } from 'react';
import { GridComponent, ColumnsDirective, ColumnDirective, Inject, Sort, Search, Toolbar, VirtualScroll } from '@syncfusion/ej2-react-grids';

import AddPopup from './AddPopup';

import useFetchIntervenants from '../hooks/useFetchIntervenants';

const ListContact = ({ lstContacts, showAddButton = true, size = 520, setSelectedRow = null, handleRowDoubleClick = null, loading = false, intervenantUUID = null }) => {

    const { fetchAddContact } = useFetchIntervenants();

    const [showPopup, setShowPopup] = useState(false);

    const contactFields = [
        { name: "Nom", label: "Nom", placeholder: "Nom du contact", type: "text", required: true },
        { name: "Prenom", label: "Prénom", placeholder: "Prénom du contact", type: "text", required: false },
        { name: "Email", label: "Email", placeholder: "Email du contact", type: "email", required: true },
        { name: "Adresse1", label: "Adresse 1", placeholder: "Adresse du contact", type: "text", required: false },
        { name: "Adresse2", label: "Adresse 2", placeholder: "Complément d'adresse", type: "text", required: false },
        { name: "CP", label: "Code Postal", placeholder: "Code postal du contact", type: "text", required: false },
        { name: "Ville", label: "Ville", placeholder: "Ville du contact", type: "text", required: false },
        { name: "Pays", label: "Pays", placeholder: "Pays du contact", type: "text", required: false },
        { name: "LinkedIn", label: "LinkedIn", placeholder: "Lien LinkedIn", type: "url", required: false },
        { name: "Fax", label: "Fax", placeholder: "Numéro de fax", type: "tel", required: false },
        { name: "Mobile", label: "Mobile", placeholder: "Numéro de mobile", type: "tel", required: false },
        { name: "Fonction", label: "Fonction", placeholder: "Fonction du contact", type: "text", required: false },
        { name: "Poste", label: "Poste", placeholder: "Poste du contact", type: "text", required: false }
    ];


    const [newContact, setNewContact] = useState({
        Nom: '',
        Prenom: '',
        Email: '',
        Adresse1: '',
        Adresse2: '',
        CP: '',
        Ville: '',
        Pays: '',
        LinkedIn: '',
        Fax: '',
        Mobile: '',
        Fonction: '',
        Poste: '',
    });

    const handleOpenPopup = () => {
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        setNewContact({
            Nom: '',
            Prenom: '',
            Email: '',
            Adresse1: '',
            Adresse2: '',
            CP: '',
            Ville: '',
            Pays: '',
            LinkedIn: '',
            Fax: '',
            Mobile: '',
            Fonction: '',
            Poste: '',
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewContact((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAddContact = () => {
        if (!intervenantUUID) {
            return;
        }
        const contactToAdd = { ...newContact, IntervenantUUID: intervenantUUID };
        fetchAddContact(contactToAdd);
        lstContacts.push(contactToAdd);
        handleClosePopup();
    };

    const columns = [
        { field: "Nom", headerText: "Nom", width: "180px" },
        { field: "Prenom", headerText: "Prénom", width: "180px" },
        { field: "Email", headerText: "Em@il", width: "230px" },
        { field: "Adresse1", headerText: "Adresse 1", width: "230px" },
        { field: "Adresse2", headerText: "Adresse 2", width: "230px" },
        { field: "CP", headerText: "Code Postal", width: "100px" },
        { field: "Ville", headerText: "Ville", width: "180px" },
        { field: "Pays", headerText: "Pays", width: "150px" },
        { field: "LinkedIn", headerText: "LinkedIn", width: "200px" },
        { field: "Fax", headerText: "Fax", width: "180px" },
        { field: "Mobile", headerText: "Mobile", width: "180px" },
        { field: "Fonction", headerText: "Fonction", width: "200px" },
        { field: "Poste", headerText: "Poste", width: "200px" },
        { field: "_Date_Crea", headerText: "Créé le", type: "date", format: "dd/MM/yyyy", width: "130px" },
        { field: "_Date_Modif", headerText: "modifié le", type: "date", format: "dd/MM/yyyy", width: "130px" },
        { field: "_Creer_par", headerText: "Créé par", width: "130px" }
    ];

    return (
        <div className="bg-white p-4 rounded-lg">
            <div className="flex lg:flex-row flex-col justify-between items-start lg:items-center mx-auto my-4 lg:my-8 px-6 pb-4 border-gray-300 border-b container">
                <div>
                    <h4 className="font-bold text-gray-800 text-2xl leading-tight">Contacts</h4>
                    <ul className="flex md:flex-row flex-col items-start md:items-center mt-3 text-gray-600 text-sm">
                        <li className="flex items-center mt-3 md:mt-0 mr-3">
                            <span className="mr-2">
                                <i className="fa-user fas"></i>
                            </span>
                            <div className="flex items-center gap-1">
                            {loading ? (
                                    <div className="bg-gray-200 rounded-md w-9 h-4 animate-pulse"></div>
                                ) : (
                                    <span>{lstContacts.length}</span>
                                )}
                                {' '}{lstContacts.length === 1 ? 'Contact' : 'Contacts'}
                            </div>
                        </li>
                    </ul>
                </div>
                {showAddButton && (
                    <div className="mt-6 lg:mt-0">
                        <button
                            onClick={handleOpenPopup}
                            className="bg-orange-600 hover:bg-orange-500 px-8 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-orange-700 focus:ring-offset-2 text-white text-sm transition duration-300 ease-in-out"
                        >
                            Ajouter un Contact
                        </button>
                    </div>
                )}
            </div>

            <div className="lg:mx-auto mb-4 lg:mb-8 px-6 container">
                <div className="border-2 border-gray-300 hover:border-orange-400 rounded w-full transition duration-300 ease-in-out grow">
                    <GridComponent
                        dataSource={lstContacts}
                        allowSorting={true}
                        height={size}
                        toolbar={['Search']}
                        searchSettings={{
                            fields: ['Nom', 'Email', 'Fonction', 'Poste'],
                            placeholder: 'Rechercher...',
                        }}
                        rowSelected={(args) => {
                            if (setSelectedRow) {
                                setSelectedRow(args.data);
                            }
                        }}
                    >
                        <ColumnsDirective>
                            {columns.map(col => (
                                <ColumnDirective key={col.field} {...col} />
                            ))}
                        </ColumnsDirective>
                        <Inject services={[Sort, Search, Toolbar, VirtualScroll]} />
                    </GridComponent>
                </div>
            </div>

            <AddPopup
                showPopup={showPopup}
                handleClosePopup={handleClosePopup}
                handleChange={handleChange}
                handleAddItem={handleAddContact}
                fields={contactFields}
                type={"Contact"}
                formData={newContact}
            />

        </div>
    );
};

export default ListContact;
